import { useEffect, useState } from 'react';

/** Below 700 px the cost and "Make it" stick to the bottom of the page (design release-kit t5b). */
const NARROW_QUERY = '(max-width: 699.98px)';

function matches(): boolean {
  return (
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(NARROW_QUERY).matches
  );
}

/**
 * True below 700 px: a phone, a narrow window, the Studio web view of the native apps. Then the
 * rail shows the sticky make bar in place of the full credit block. Without `matchMedia` (jsdom)
 * the answer is false.
 */
export function useIsNarrowCreditBar(): boolean {
  const [narrow, setNarrow] = useState(matches);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const query = window.matchMedia(NARROW_QUERY);
    const update = () => setNarrow(query.matches);
    update();
    query.addEventListener?.('change', update);
    return () => query.removeEventListener?.('change', update);
  }, []);
  return narrow;
}
